import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postGenerateCostReport } from '../services/postGenerateCostReport.service';

export const generateCostReport = createAsyncThunk(
  'expenseTracking/generateCostReport',
  async (
    { recordsFromDate, recordsToDate, invoicesFromDate, invoicesToDate },
    { getState }
  ) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    const report = await postGenerateCostReport(selectedProjectId, {
      recordsFromDate,
      recordsToDate,
      invoicesFromDate,
      invoicesToDate,
    });

    return report;
  }
);
